import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router-dom';

import { AnalyticsEvent } from 'applications/GSP/shared/constants/analytics';
import { useAnalytics } from 'applications/GSP/shared/hooks/analytics';
import { InfoTemplate } from 'shared/components/InfoTemplate';
import { Button } from 'shared/components/buttons/Button';
import { IS_DEVELOPMENT } from 'shared/config/env';

import { ReactComponent as Image } from './assets/images/somethingWentWrong.svg';

import type { FC } from 'react';

export const ROOT_BOUNDARY_TEST_ID = 'root-boundary';

export const RootBoundary: FC = () => {
  const analytics = useAnalytics();
  const error = useRouteError();
  const { t } = useTranslation();

  const onClick = useCallback(() => {
    window.location.reload();
  }, []);

  useEffect(() => {
    analytics.track(AnalyticsEvent.UncaughtError, {
      error:
        error instanceof Error
          ? { message: error.message, stack: error.stack }
          : error,
    });

    if (IS_DEVELOPMENT) {
      window.console.error(`${AnalyticsEvent.UncaughtError}:`, error);
    }
  }, [analytics, error]);

  return (
    <InfoTemplate
      data-testid={ROOT_BOUNDARY_TEST_ID}
      size="lg"
      header={t('GSP.pages.rootBoundary.header')}
      description={t('GSP.pages.rootBoundary.description')}
      action={
        <Button
          sx={{ borderRadius: '24px' }}
          variant="contained"
          size="large"
          onClick={onClick}
        >
          {t('GSP.pages.rootBoundary.refreshPage')}
        </Button>
      }
    >
      {/* TODO: add aria-label after an accessibility research */}
      {imageProps => <Image {...imageProps} />}
    </InfoTemplate>
  );
};
